export enum jsonStatusPropertyComparisonTypes {
  EQUAL = 'EQUAL',
  NOT_EQUAL = 'NOT_EQUAL',
  HAS_VALUE = 'HAS_VALUE',
  NULL = 'NULL',
  PROPERTY_NOT_EXIST = 'PROPERTY_NOT_EXIST',
}
